export const brandOptions = [
  { name: "Givenchy", val: "Givenchy" },
  { name: "Gucci", val: "Gucci" },
  { name: "Lenon", val: "Lenon" },
  { name: "Lululemon", val: "Lululemon" },
  { name: "Dior", val: "Dior" },
  { name: "Cartier", val: "Cartier" },
];

export const priceOptions = [
  { name: "$100-$200", val: "100-200" },
  { name: "$200-$300", val: "200-300" },
  { name: "$400-$500", val: "400-500" },
  { name: "$500-$999", val: "500-2000" },
];

export const categoryOptions = [
  { name: "Blazers", val: "blazer" },
  { name: "Shirts", val: "shirt" },
  { name: "Knitwear", val: "knitwear" },
  { name: "T-shirts", val: "tshirt" },
  { name: "Coats", val: "coat" },
  { name: "Hat", val: "hat" },
  { name: "Trouser", val: "trouser" },
];
